import { createAsyncThunk } from "@reduxjs/toolkit";
import AiInsightsAPI, {
    InsightsResponse,
    GenerateInsightsRequest,
    InsightsKey
} from "../../../api/aiInsights";
import { RootState } from "../../../app/store";

export const fetchInsightsThunk = createAsyncThunk<
    InsightsResponse,
    {caseId: string, insightKeys?: InsightsKey[]},
    { state: RootState; rejectValue: string }
>(
    'aiInsights/fetch',
    async ({caseId, insightKeys }, { rejectWithValue }) => {
        try {
            return await AiInsightsAPI.get({ case_id: caseId, insight_keys: insightKeys });
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch insights');
        }
    },
    {
        condition({caseId, insightKeys}, {getState}) {
            const insights_state = getState().insightsData;

            if(insightKeys)
                return true;
            
            if(caseId === insights_state.caseId && insights_state.status === 'succeeded' || insights_state.status === 'loading') {
                return false;
            }

            return true;
        }
    }
);

export const generateInsightsThunk = createAsyncThunk<
    InsightsResponse,
    { caseId: string; product: string; insightKeys?: InsightsKey[] },
    { state: RootState; rejectValue: string }
>(
    'aiInsights/generate',
    async ({ caseId, product, insightKeys }, { rejectWithValue }) => {
        
        const generate_request: GenerateInsightsRequest = {
            product: product,
            insight_key: insightKeys
        };
        
        try {
            return await AiInsightsAPI.generate({ case_id: caseId, request: generate_request });
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to generate insights');
        }
    }
);